import React from 'react';
import PageWrapper from '@gruponewway/aquisicao-page-wrapper';

function MyPageWrapper(props) {
  // eslint-disable-next-line no-underscore-dangle
  return <PageWrapper {...props} isClient={global.__CLIENT__ ?? false} />;
}

export default MyPageWrapper;
